import { Units as CoreUnits } from '@yanolja-rnd/ya-com-core';

const Units = {
  ...CoreUnits,
  // Add your custom units here
  pcWidthRem: CoreUnits.PC_WIDTH / 10,
  mobileWidthRem: 36 as const,
  headerHeightRem: 4.8 as const,

  MEDIUM_MOBILE_WIDTH_PX: 375,
  SMALL_MOBILE_WIDTH_PX: 320,
  MIN_SCREEN_WIDTH_PX: 320,
};

export { Units };
